import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
    { to: "/", label: "Accueil" },
    { to: "/galerie", label: "Galeries" },
    { to: "/a-propos", label: "À propos" },
    { to: "/tarifs", label: "Tarifs" },
    { to: "/temoignages", label: "Témoignages" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = React.useState(false);
    const location = useLocation();

    React.useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <nav
            data-testid="main-navbar"
            className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
        >
            <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="font-serif-display text-xl md:text-2xl tracking-wide"
                >
                    paul<span className="text-[#c5a059]">.</span>mv07
                    <span className="text-zinc-500 text-sm ml-2 hidden sm:inline">
                        photography
                    </span>
                </Link>

                <ul className="hidden md:flex items-center gap-10 text-sm">
                    {NAV.map((n) => (
                        <li key={n.to}>
                            <NavLink
                                to={n.to}
                                data-testid={`nav-${n.to.replace("/", "") || "home"}`}
                                className={({ isActive }) =>
                                    `uppercase tracking-[0.18em] transition-colors ${
                                        isActive
                                            ? "text-[#c5a059]"
                                            : "text-zinc-300 hover:text-white"
                                    }`
                                }
                                end
                            >
                                {n.label}
                            </NavLink>
                        </li>
                    ))}
                </ul>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="md:hidden text-white"
                    aria-label="Menu"
                >
                    {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
                    <ul className="flex flex-col px-6 py-4 gap-4 text-sm">
                        {NAV.map((n) => (
                            <li key={n.to}>
                                <NavLink
                                    to={n.to}
                                    data-testid={`nav-mobile-${n.to.replace("/", "") || "home"}`}
                                    className={({ isActive }) =>
                                        `uppercase tracking-[0.18em] block py-2 ${
                                            isActive ? "text-[#c5a059]" : "text-zinc-300"
                                        }`
                                    }
                                    end
                                >
                                    {n.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </nav>
    );
}
